import React from 'react'

export default () => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="currentColor" fillRule="evenodd">
      <path d="M5.657 0L0 5.657l.707.707L6.364.707z" />
      <path d="M6.364 10.607L.707 4.95 0 5.657l5.657 5.657z" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/backIcon.js